import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootReducerState } from '../../redux/Reducers';
import {
  CreateWholesaleBillingSettingsDto,
  UpdateWholesaleBillingSettingsDto,
  WholesaleBillingSettingsEntityType,
  WholesaleBillingSettingsType,
} from '../../types/wholesale-billing-settings/wholesaleBillingSettings.types';
import { rejectWithApiError } from '../../utils/api';

export const getWholesaleBillingSettings = createAsyncThunk<
  WholesaleBillingSettingsType | null,
  number,
  { state: RootReducerState; rejectValue: string }
>('wholesaleBillingSettings/getWholesaleBillingSettings', async (organizationId, thunkAPI) => {
  try {
    const response = await axios.get<WholesaleBillingSettingsType | '' | null>(
      `${process.env.REACT_APP_API_URL}/wholesale/billing-settings/${organizationId}`
    );

    return response.data || null;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching wholesale billing settings!' });
  }
});

export const createWholesaleBillingSettings = createAsyncThunk<
  WholesaleBillingSettingsEntityType,
  CreateWholesaleBillingSettingsDto,
  { state: RootReducerState; rejectValue: string }
>('wholesaleBillingSettings/createWholesaleBillingSettings', async (data, thunkAPI) => {
  try {
    const response = await axios.post<WholesaleBillingSettingsEntityType>(
      `${process.env.REACT_APP_API_URL}/wholesale/billing-settings`,
      data
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error creating wholesale billing settings!' });
  }
});

export const updateWholesaleBillingSettings = createAsyncThunk<
  WholesaleBillingSettingsEntityType,
  { id: number; data: UpdateWholesaleBillingSettingsDto },
  { state: RootReducerState; rejectValue: string }
>('wholesaleBillingSettings/updateWholesaleBillingSettings', async ({ id, data }, thunkAPI) => {
  try {
    const response = await axios.put<WholesaleBillingSettingsEntityType>(
      `${process.env.REACT_APP_API_URL}/wholesale/billing-settings/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error updating wholesale billing settings!' });
  }
});
